import { BaseItem, TableProps } from '@lib/components/Table/types';
import { checkHasSelectColumn } from './checkHasSelectColumn';
import { checkHasActionsColumn } from './checkHasActionsColumn';

export const getColumnsCount = <T extends BaseItem>(
  props: TableProps<T>,
): number => {
  const { columns } = props;
  const hasSelectColumn = checkHasSelectColumn(props);
  const hasActionsColumn = checkHasActionsColumn(props);
  return (
    columns.length + (hasSelectColumn ? 1 : 0) + (hasActionsColumn ? 1 : 0)
  );
};
